/**
 * @file _view/_validate.js
 */


(function ($) {
	'use strict';

	// options
	var validateOption = {
		errorClassName   : 'error',
		parentClassName  : 'form-group',
		sysErrorAlert    : false,
		useParentError   : true,
		specialCharCheck : false,
		showAsPopup      : false,
		errorMsgClassName: 'error-message'
	};

	/**
	 *
	 * @namespace Validate
	 * @constructor
	 * @classdesc form validator
	 * @param {jQuery} $e - 対象となる jQuery オブジェクト
	 */
	var Validate = function ($e) {
		this._$e = $e;
		console.info(this._$e);
		$(window).on('load', this.validator.bind(this));
	};


	/**
	 *
	 * memberof Validate
	 * @const {string}
	 */
	Validate._classname = 'Validate';


	Validate.prototype.validator = function () {
		$(document).on('blur', 'input.validate', function () {
			$(this).WizValidator(validateOption);
		});
		$(document).on('change', 'select.validate', function () {
			$(this).WizValidator(validateOption);
		});
		$(document).on('blur', 'textarea.validate', function () {
			$(this).WizValidator(validateOption);
		});
	};


	module.exports = Validate;
})(jQuery);